import React, { Component } from 'react'
import { connect } from 'react-redux'
import ScrollIndicator from '../../../../../../../TablaDePosiciones/Components/ScrollIndicator'
import Toggle from '../Toogle'
import PlayerCardWithEvent from '../PlayerCardWithEvent'
import SquadPlayerCard from '../SquadPlayerCard'
import Device from '../../../../../../../../../devices/device'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Utils from '../../../../../../../../../utils/Utils'
import Asset from '../../../../../../../../../requests/apa/Asset'
import './_styles.scss'
import { sendMetricScroll } from '../../../../../../../utils'
import { setToggleState } from '../../../../../../../../../actions/toggles'

// Formación 4-3-3: GK (top) → 4 defensas → 3 medios → 3 delanteros (bottom)
// Posiciones en px dentro del campo 592×600

/**
 * SquadBody
 * Cuerpo del tab "Plantilla" del detalle de país.
 *
 * Props:
 *  children        {node}   — contenido scrolleable
 *  bodyRef         {func}   — ref para el div de scroll
 *  onScrollKeyDown {func}   — handler del ScrollIndicator
 *  scrollRatio     {number} — posición del thumb (0-1)
 *  trackHeightRem  {number} — alto del track en rem
 *  thumbHeightRem  {number} — alto del thumb en rem
 */
class SquadBody extends Component {
  constructor (props) {
    super(props)
    this.state = {
      scrollTop: 0,
      maxScroll: 0
    }
    this.scrollRef = null
    this.handleToggleKeyDown = this.handleToggleKeyDown.bind(this)
    this.handleToggleChange = this.handleToggleChange.bind(this)
    this.handleScrollKeyDown = this.handleScrollKeyDown.bind(this)
    this.setScrollRef = function (el) { this.scrollRef = el; if (el) el.scrollTop = this.state.scrollTop }.bind(this)
    this.keys = Device.getDevice().getKeys()
    this.scrollMilestonesSent = new Set()
  }

  componentDidMount () {
    setTimeout(function () {
      var toggle = document.querySelector('.squad-body__header .toggle')
      if (toggle) toggle.focus()
    }, 0)
  }

  handleToggleChange (active) {
    this.props.setToggleState('squad-body', active)
  }

  handleToggleKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'UP' && currentKey !== 'DOWN' && currentKey !== 'LEFT') return
    e.preventDefault()
    e.stopPropagation()
    if (currentKey === 'UP') {
      var mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
      // var mainMenuTab = activeText ? activeText.closest('.focusable') : null
      if (mainMenuTab) mainMenuTab.focus()
    } else {
      var scrollIndicator = document.querySelector('.country-details-body__scrollbar')
      if (scrollIndicator) scrollIndicator.focus()
    }
  }

  handleScrollKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (!currentKey) return

    const el = this.scrollRef
    const STEP = 310
    const MAX_SCROLL = el ? el.scrollHeight - el.clientHeight : 0
    var next = this.state.scrollTop

    if (currentKey === 'UP') {
      e.preventDefault()
      e.stopPropagation()
      if (this.state.scrollTop === 0) {
        var toggle = document.querySelector('.squad-body__header .toggle')
        if (toggle) toggle.focus()
        return
      }
      next = Math.max(0, next - STEP)
    } else if (currentKey === 'DOWN') {
      e.preventDefault()
      e.stopPropagation()
      next = Math.min(MAX_SCROLL, next + STEP)
    } else if (currentKey === 'RIGHT') {
      e.preventDefault()
      e.stopPropagation()
      var toggle = document.querySelector('.squad-body__header .toggle')
      if (toggle) toggle.focus()
      return
    } else {
      return
    }

    this.setState({ scrollTop: next, maxScroll: MAX_SCROLL })
    if (this.scrollRef) this.scrollRef.scrollTop = next

    const prevPercent = MAX_SCROLL > 0 ? Math.round(this.state.scrollTop / MAX_SCROLL * 100) : 0
    const nextPercent = MAX_SCROLL > 0 ? Math.round(next / MAX_SCROLL * 100) : 0
        
    const mainMenuLabel =  this.props.mainMenuLabel
    const parentTabLabel = this.props.parentTabLabel
    const childTabLabel = this.props.childTabLabel

    if (currentKey === 'DOWN') {
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (prevPercent < m && m <= nextPercent && !this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.add(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
        }
      })
      if (next >= MAX_SCROLL && !this.scrollMilestonesSent.has(100)) {
        this.scrollMilestonesSent.add(100)
        sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, 100)
      }
    } else {
      if (prevPercent === 100 && nextPercent < 100) {
        this.scrollMilestonesSent.delete(100)
      }
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (nextPercent < m && m <= prevPercent && this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.delete(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
        }
      })
    }
  }

  createFormation = (porteros, defensas, medios, delanteros, alineacion, typeMovements) => {
    if (!porteros || !defensas || !medios || !delanteros || !alineacion) return []

    var mapPlayer = function (player) {
      if (!player) return null
      var playerMovements = player.movements && player.movements.length > 0 ? player.movements : []
      var goals = 0
      var topLeftIconUrl, topRightIconUrl, bottomRightIconUrl, bottomLeftIconUrl
      playerMovements.forEach(function (movement) {
        var movementTypeInfo = typeMovements[movement.type]
        if (movementTypeInfo) {
          if (movement.type === 'GOAL') {
            goals++
            bottomRightIconUrl = movementTypeInfo.iconKeyAsset
          } else if (movement.type === 'YELLOW_CARD' || movement.type === 'RED_CARD') {
            bottomLeftIconUrl = movementTypeInfo.iconKeyAsset
          } else if (movement.type === 'SECOND_YELLOW_RED_CARD') {
            topLeftIconUrl = movementTypeInfo.iconKeyAsset
          } else if (movement.type === 'SUBSTITUTION_IN' || movement.type === 'SUBSTITUTION_OUT') {
            topRightIconUrl = movementTypeInfo.iconKeyAsset
          }
        }
      })
      return {
        id: player.playerId,
        playerName: player.name,
        photoUrl: player.image,
        playerMovements: player.movements,
        topLeftIconUrl: topLeftIconUrl,
        topRightIconUrl: topRightIconUrl,
        bottomRightIconUrl: bottomRightIconUrl,
        bottomLeftIconUrl: bottomLeftIconUrl,
        goals: goals
      }
    }

    var portero = porteros.find(function (p) { return p.isStarter })
    var allPlayers = defensas.filter(function (p) { return p.isStarter })
      .concat(medios.filter(function (p) { return p.isStarter }))
      .concat(delanteros.filter(function (p) { return p.isStarter }))

    var formation = alineacion.split('-').map(Number)
    var cursor = 0
    var formationData = formation.map(function (numberPlayers) {
      var players = allPlayers.slice(cursor, cursor + numberPlayers).map(mapPlayer)
      cursor += numberPlayers
      return players
    })
    return [portero ? [mapPlayer(portero)] : []].concat(formationData)
  }   

  render () {
    var children = this.props.children
    var trackHeightRem = this.props.trackHeightRem
    var thumbHeightRem = this.props.thumbHeightRem
    var scrollTop = this.state.scrollTop
    var maxScroll = this.state.maxScroll
    var scrollRatio = maxScroll > 0 ? scrollTop / maxScroll : 0

    var toggleActive = this.props.toggleActive || false
    // Si toggleActive es false, se muestran solo los titulares (isStarter = true). Si es true, se muestran todos los jugadores.
    var filterPlayers = function (list) {
      if (!list) return []
      return toggleActive ? list : list.filter(function (p) { return p.isStarter === true })
    }

    const borderColor = this.props.team ? this.props.team.primaryHex : '';

    // const iconBalon = Utils.cutPlayerString(Translator.get('eventodeportivo_icono_gol_2'), 1);
    const iconBalon = Asset.get('eventodeportivo_icono_gol_2');
    const iconYellowCard = Asset.get('eventodeportivo_icono_amarilla_2');
    const iconRedCard = Asset.get('eventodeportivo_icono_roja_2');
    const iconSecondYellowRedCard = Asset.get('eventodeportivo_icono_amarillaroja_2');
    const iconSubstitutionIn = Asset.get('eventodeportivo_icono_entra');
    const iconSubstitutionOut = Asset.get('eventodeportivo_icono_sale');

    const typeMovements = {
      'GOAL': { iconKeyAsset: iconBalon, label: 'Icono balón' },
      'YELLOW_CARD': { iconKeyAsset: iconYellowCard, label: 'Icono tarjeta amarilla' },
      'RED_CARD': { iconKeyAsset: iconRedCard, label: 'Icono tarjeta roja' },
      'SECOND_YELLOW_RED_CARD': { iconKeyAsset: iconSecondYellowRedCard, label: 'Icono tarjeta amarilla/roja' },
      'SUBSTITUTION_IN': { iconKeyAsset: iconSubstitutionIn, label: 'Icono flecha verde entra' },
      'SUBSTITUTION_OUT': { iconKeyAsset: iconSubstitutionOut, label: 'Icono flecha roja sale' },
    }

    var dataLineups = this.props.dataLineups

    const porteros = dataLineups && dataLineups.goalkeeper;
    const defensas = dataLineups && dataLineups.defenders;
    const medios = dataLineups && dataLineups.midfielders;
    const delanteros = dataLineups && dataLineups.forwards;
    const alineacion = dataLineups && dataLineups.lastLineup && dataLineups.lastLineup.match && dataLineups.lastLineup.match.formation;

    const formationResult = dataLineups && this.createFormation(porteros, defensas, medios, delanteros, alineacion, typeMovements);
    
    var formationToField = []
    
    if (dataLineups) {
      var formationGroups = ['goalkeeper', 'defenders', 'midfielders', 'forwards']
      formationGroups.forEach(function (group) {
        var arr = dataLineups[group]
        if (!arr) return
        
        arr.forEach(function (player) {
          if (player.showInFormationMap && player.formationMap) {
            const playerMovements = player.movements && player.movements.length > 0 ? player.movements : [];
            let goals = 0;
            playerMovements.forEach((movement) => {
              const movementTypeInfo = typeMovements[movement.type]
              
              if (movementTypeInfo) {
                if (movement.type === 'GOAL') {
                  goals++;
                  player.bottomRightIconUrl = movementTypeInfo.iconKeyAsset
                } else if (movement.type === 'YELLOW_CARD' || movement.type === 'RED_CARD') {
                  player.bottomLeftIconUrl = movementTypeInfo.iconKeyAsset
                } else if (movement.type === 'SECOND_YELLOW_RED_CARD') {
                  player.topLeftIconUrl = movementTypeInfo.iconKeyAsset
                } else if (movement.type === 'SUBSTITUTION_IN' || movement.type === 'SUBSTITUTION_OUT') {
                  player.topRightIconUrl = movementTypeInfo.iconKeyAsset
                }
              }
            })
            formationToField.push({
              id: player.playerId,
              playerName: player.name,
              photoUrl: player.image,
              left: player.formationMap.x,
              top: player.formationMap.y,
              playerMovements: player.movements,
              topLeftIconUrl: player.topLeftIconUrl,
              topRightIconUrl: player.topRightIconUrl,
              bottomRightIconUrl: player.bottomRightIconUrl,
              bottomLeftIconUrl: player.bottomLeftIconUrl,
              goals: goals
            })
          }
        })
      })
    }

    const mediaCancha = Asset.get('eventodeportivo_imagen_mediacancha');
    const overlayPhotoUrl = Asset.get('eventodeportivo_placeholder_imagen_jugador_1')

    const lastLineupMatch = this.props.dataLineups && this.props.dataLineups.lastLineup && this.props.dataLineups.lastLineup.match
    const displayDate = lastLineupMatch && lastLineupMatch.displayDate
    const displayTime = lastLineupMatch && lastLineupMatch.displayTime
    const timeZoneLabel = lastLineupMatch && lastLineupMatch.timeZoneLabel
    const dateAndTimeLabel = displayDate && displayTime && timeZoneLabel ? `${displayDate} | ${displayTime} / ${timeZoneLabel}` : ''

    return (
    <div className='squad-body'>
      <div className='squad-body__header' onKeyDown={this.handleToggleKeyDown}>
        <Toggle active={toggleActive} label={Utils.cutPlayerString(Translator.get('eventodeportivo_paises_texto_titulo_verplantillacompleta'), 24)} onChange={this.handleToggleChange} />
      </div>
      <div
        className='squad-body__scroll'
        ref={this.setScrollRef}
      >
        <div className='squad-body__content'>
          <div className='squad-body__left'>
            <div className='squad-body__last-lineup'>
              <p className='squad-body__last-lineup-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_ultimalineacion'), 24)}</p>
              <p className='squad-body__last-lineup-match-label'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_partido'), 20)}</p>
              <p className='squad-body__last-lineup-match-date'>{Utils.cutPlayerString(dateAndTimeLabel, 25)}</p>
            </div>
            <div className='squad-body__formation'>
              <div className='squad-body__field'>
                <div className='squad-body__field-penalty' />
                <div className='squad-body__field-goal' />
                <div className='squad-body__field-circle' />
              </div>
              {/* {formationToField.map(function (player) {
                // const positionLeft = (player.left / 100 ) * 40; // width: 40rem; -> 600 px
                // const positionTop = (player.top / 100 ) * 40; // height: 39.47rem; -> 592 px
                return (
                  <div
                    key={player.id}
                    className='squad-body__player-pos'
                    style={{ left: `${player.left}%`, top: `${player.top}%` }}
                  >
                    <PlayerCardWithEvent
                      playerName={player.playerName}
                      photoUrl={player.photoUrl}
                      playerMovements={player.playerMovements}
                      topLeftIconUrl={player.topLeftIconUrl}
                      topRightIconUrl={player.topRightIconUrl}
                      bottomRightIconUrl={player.bottomRightIconUrl}
                      bottomLeftIconUrl={player.bottomLeftIconUrl}
                      goals={player.goals}
                      borderColor={borderColor}
                    />
                  </div>
                )
              })} */}

              {
                formationResult && formationResult.map((players, rowIndex) => {
                  return (
                    <div key={rowIndex} className='squad-body__formation-row'>
                    {
                      players.map(player => (
                        <div key={player.id} className='squad-body__formation-player' >
                          <PlayerCardWithEvent
                            playerName={player.playerName}
                            photoUrl={player.photoUrl || overlayPhotoUrl}
                            playerMovements={player.playerMovements}
                            topLeftIconUrl={player.topLeftIconUrl}
                            topRightIconUrl={player.topRightIconUrl}
                            bottomRightIconUrl={player.bottomRightIconUrl}
                            bottomLeftIconUrl={player.bottomLeftIconUrl}
                            goals={player.goals}
                            borderColor={borderColor}
                          />
                        </div>
                      ))
                    }
                  </div> )
                })
              }

            </div>
            <p className='squad-body__formation-label'>{Utils.cutPlayerString(lastLineupMatch && lastLineupMatch.formation, 7)}</p>
          </div>
          <div className='squad-body__right'>
            <div className='squad-body__right-section'>
              <p className='squad-body__right-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_entrenador'), 34)}</p>
              <SquadPlayerCard
                playerName={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.name}
                birthDate={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.displayBirthDate}
                age={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.age}
                displayInfoBirthDate={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.displayInfo}
                jerseyNumber={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.number}
                photoUrl={this.props.dataLineups && this.props.dataLineups.coach && this.props.dataLineups.coach.image || overlayPhotoUrl}
              />
            </div>
            <div className='squad-body__right-section'>
              <p className='squad-body__right-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_portero'), 34)}</p>
              {
                filterPlayers(this.props.dataLineups && this.props.dataLineups.goalkeeper).map((player, index) => (
                    <SquadPlayerCard
                      key={player.playerId}
                      playerName={player.name}
                      birthDate={player.displayBirthDate}
                      age={player.age}
                      displayInfoBirthDate={player.displayInfo}
                      jerseyNumber={player.number}
                      photoUrl={player.image || overlayPhotoUrl}
                      substitution={player.movements}
                      displayDateToSubstitutions={displayDate}
                    />
                  ))
              }
            </div>
            <div className='squad-body__right-section'>
              <p className='squad-body__right-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_defensa'), 34)}</p>
              {
                filterPlayers(this.props.dataLineups && this.props.dataLineups.defenders).map((player, index) => (
                    <SquadPlayerCard
                      key={player.playerId}
                      playerName={player.name}
                      birthDate={player.displayBirthDate}
                      age={player.age}
                      displayInfoBirthDate={player.displayInfo}
                      jerseyNumber={player.number}
                      photoUrl={player.image || overlayPhotoUrl}
                      substitution={player.movements}
                      displayDateToSubstitutions={displayDate}
                    />
                  ))
              }
            </div>
            <div className='squad-body__right-section'>
              <p className='squad-body__right-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_Mediocampista'), 34)}</p>
              {
                filterPlayers(this.props.dataLineups && this.props.dataLineups.midfielders).map((player, index) => (
                    <SquadPlayerCard
                      key={player.playerId}
                      playerName={player.name}
                      birthDate={player.displayBirthDate}
                      age={player.age}
                      displayInfoBirthDate={player.displayInfo}
                      jerseyNumber={player.number}
                      photoUrl={player.image || overlayPhotoUrl}
                      substitution={player.movements}
                      displayDateToSubstitutions={displayDate}
                    />
                  ))
              }
            </div>
            <div className='squad-body__right-section'>
              <p className='squad-body__right-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_partidos_jugadores_texto_titulo_delanteros'), 34)}</p>
              {
                filterPlayers(this.props.dataLineups && this.props.dataLineups.forwards).map((player, index) => (
                    <SquadPlayerCard
                      key={player.playerId}
                      playerName={player.name}
                      birthDate={player.displayBirthDate}
                      age={player.age}
                      displayInfoBirthDate={player.displayInfo}
                      jerseyNumber={player.number}
                      photoUrl={player.image || overlayPhotoUrl}
                      substitution={player.movements}
                      displayDateToSubstitutions={displayDate}
                    />
                  ))
              }
            </div>
          </div>
        </div>
        {/* {children} */}
      </div>
      <ScrollIndicator
        onKeyDown={this.handleScrollKeyDown}
        scrollRatio={scrollRatio}
        className='country-details-body__scrollbar'
        // className='stats-body__scrollbar'
        trackHeightRem={34.67}
        thumbHeightRem={11.4}
      />
    </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    toggleActive: state.toggles['squad-body']
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setToggleState: function (toggleId, active) {
      return dispatch(setToggleState(toggleId, active))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SquadBody)



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/SquadBody/index.jsx